import React, { useState } from 'react';
import { Tile, TileText } from '@one-thd/sui-atomic-components';
import { Calendar, ArrowDown } from '@one-thd/sui-icons';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { getDateRangeFilterText } from '../../../utils/purchase-history/common';
import { OrderFilterDateDrawer } from './OrderFilterDateDrawer';

export const DateFilter = () => {
  const { dateSelectorValue, pHRequest } = usePurchaseHistoryContext();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => setIsDrawerOpen(true);

  return (
    <div className="sui-min-w-72 sui-flex">
      <Tile
        aria-label="Date Placed"
        onClick={openDrawer}
        tabIndex={0}
        onKeyDown={(event: React.KeyboardEvent) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openDrawer();
          }
        }}
        data-testid="date-filter-tile"
        grow
      >
        <div className="sui-flex sui-gap-2 sui-px-2 sui-items-center">
          <Calendar size="small" />
          <TileText height="tight">
            Date Placed: {getDateRangeFilterText(dateSelectorValue, pHRequest)}
          </TileText>
          <ArrowDown size="small" />
        </div>
      </Tile>
      <OrderFilterDateDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />
    </div>
  );
};
